var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-picture-wrapper"},[_c('img',{staticClass:"no-video",attrs:{"src":_vm.image}})])
}
var staticRenderFns = []

export { render, staticRenderFns }